// Daily grow tips spoken by the hero animals. Index rotates with the day of the year.
// Toucan tips for the grow week chosen in the irrigation section (doses match the Jungle table).
export const PHASE_TIPS = {
  C1: [
    "Semana 1 de crecimiento: Grow 150 ml por 100 L (1,5 mL/L). Empieza suave, las raíces jóvenes son sensibles a las sales.",
    "En plantas recién trasplantadas riega poco volumen y alrededor del tallo para que las raíces exploren.",
  ],
  C2: [
    "Semana 2 de crecimiento: sube Grow a 200 ml por 100 L. Riega lunes, miércoles y viernes; el domingo, descanso.",
    "Si las puntas de las hojas se queman, baja un poco la dosis de Grow en el siguiente riego.",
  ],
  C3: [
    "Semana 3 de crecimiento: Grow a 200 ml por 100 L, última semana con Grow.",
    "Prepara el cambio a floración: la próxima semana entra A Bloom.",
  ],
  F1: [
    "Floración S1: solo A Bloom, 100 ml por 100 L. Es la semana del estirón, deja espacio hasta la luz.",
    "Mide la EC del agua de partida: el cuadrante se calculó con EC 0,6.",
  ],
  F2: [
    "Floración S2: A Bloom sube a 400 ml por 100 L. Las plantas empiezan a formar flores.",
    "La próxima semana entran B Bloom, PK y Bongo Bloom: tenlos preparados.",
  ],
  F3: [
    "Floración S3: B Bloom 400 ml + PK 100 ml + Bongo Bloom 30 ml por 100 L. Añade primero B Bloom.",
    "Empieza la base de floración: revisa la EC tras cada mezcla para no pasarte.",
  ],
  F4: [
    "Floración S4: PK sube a 200 ml por 100 L con B Bloom 400 ml y Bongo 30 ml. Las flores engordan.",
    "Vigila la humedad: con flores densas, mejor por debajo del 50 %.",
  ],
  F5: [
    "Floración S5: B Bloom 400 ml + PK 200 ml + Bongo Bloom 30 ml por 100 L, y entra Compact (50–150 ml por 100 L) en cada riego.",
    "Con Compact empieza por la dosis baja y sube si la planta responde bien.",
  ],
  F6: [
    "Floración S6: mantén B Bloom 400 ml, PK 200 ml, Bongo Bloom 30 ml y Compact 50–150 ml por 100 L.",
    "Revisa el envés de las hojas: en plena floración cualquier plaga avanza rápido.",
  ],
  F7: [
    "Floración S7: última semana con abono. La semana que viene toca lavado con solo agua.",
    "Empieza a mirar los tricomas con lupa para calcular la cosecha.",
  ],
  F8: [
    "Semana de lavado: riega solo con agua, sin ningún nutriente.",
    "Mira los tricomas con lupa antes de cortar: lechosos para efecto activo, ámbar para más relajante.",
  ],
};
export const TIPS = {
  toucan: {
    name: "Tucán",
    role: "Nutrición",
    list: [
      "Mide el pH de la solución: 5,8–6,2 en coco o hidro y 6,2–6,8 en tierra.",
      "Riega hasta obtener un 10–20 % de drenaje para que no se acumulen sales en el sustrato.",
      "Agita cada botella y añade los nutrientes de uno en uno al agua, removiendo entre cada uno.",
      "Hojas bajas amarillentas en crecimiento suelen indicar falta de nitrógeno: revisa tu dosis de Grow.",
      "PK y Compact se pueden aplicar juntos en el mismo riego.",
      "Mide la EC del agua de partida y adapta las dosis: el cuadrante Jungle se calculó con EC 0,6.",
      "Deja que el sustrato se seque un poco entre riegos: las raíces también necesitan oxígeno.",
    ],
  },
  monkey: {
    name: "Mono",
    role: "Cultivo",
    list: [
      "Humedad al 60–70 % en crecimiento y al 40–50 % en floración para evitar hongos.",
      "Temperatura ideal: 24–28 °C con luz encendida y no menos de 18 °C de noche.",
      "Revisa el envés de las hojas dos veces por semana para detectar plagas a tiempo.",
      "Haz podas y defoliaciones con luna menguante, como marca el calendario lunar Jungle.",
      "Al pasar a floración la planta puede doblar su altura: deja espacio hasta la luz.",
      "Un ventilador suave fortalece los tallos y mantiene el aire en movimiento.",
      "Cosecha mirando los tricomas: lechosos para un efecto activo, ámbar para uno más relajante.",
    ],
  },
};

export const dayOfYear = (d = new Date()) =>
  Math.floor((Date.UTC(d.getFullYear(), d.getMonth(), d.getDate()) - Date.UTC(d.getFullYear(), 0, 0)) / 86400000);

export const tipFor = (animal, offset = 0, week = null) => {
  const phase = animal === "toucan" && PHASE_TIPS[week] ? PHASE_TIPS[week] : [];
  if (phase.length) {
    const all = [...phase, ...TIPS.toucan.list];
    return all[offset % all.length];
  }
  const list = TIPS[animal].list;
  return list[(dayOfYear() + offset) % list.length];
};
